const comment = 'text-muted';
const cmd = 'text-[oklch(75%_0.12_170)]';
const flag = 'text-[oklch(70%_0.14_85)]';
const url = 'text-accent';

function Install() {
  return (
    <section class="section" id="install">
      <div class="container">
        <div class="section-header">
          <span class="tag">Local</span>
          <h2>Prefer to run it locally?</h2>
        </div>
        <p class="text-center text-muted max-w-[560px] mx-auto mb-10 text-[0.95rem]">
          TanrenAI is open source. Skip the platform and run the same chat, agent mode,
          and memory on your own hardware — one binary, your models, your rules.
        </p>
        <div class="glass glass-glow p-8 relative">
          <pre class="font-mono text-[0.85rem] leading-[1.7] text-fg overflow-x-auto">
            <span class={comment}># 1. Install (macOS / Linux)</span>{'\n'}
            <span class={cmd}>curl</span>{' '}<span class={flag}>-fsSL</span>{' '}<span class={url}>https://raw.githubusercontent.com/ThatCatDev/tanrenai/main/installers/install.sh</span>{' | '}<span class={cmd}>sh</span>{'\n\n'}
            <span class={comment}># 2. Pull a model (HuggingFace shorthand)</span>{'\n'}
            <span class={cmd}>tanrenai</span>{' '}<span class={flag}>--local pull</span>{' '}<span class={url}>hf://unsloth/Qwen3-8B-GGUF/Q4_K_M</span>{'\n\n'}
            <span class={comment}># 3. Run locally (add --agent --memory for tools + RAG)</span>{'\n'}
            <span class={cmd}>tanrenai</span>{' '}<span class={flag}>--local run</span>{' '}Qwen3-8B-Q4_K_M
          </pre>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
          <div class="glass p-6">
            <h4 class="font-display text-[0.95rem] font-bold mb-3 flex items-center gap-2">
              <svg width="16" height="16" fill="none" stroke="var(--accent)" stroke-width="2" viewBox="0 0 24 24">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
              macOS &amp; Linux
            </h4>
            <p class="text-muted text-[0.85rem] leading-[1.5]">
              Intel &amp; Apple Silicon supported. Metal GPU acceleration on macOS,
              CUDA on Linux with NVIDIA.
            </p>
          </div>
          <div class="glass p-6">
            <h4 class="font-display text-[0.95rem] font-bold mb-3 flex items-center gap-2">
              <svg width="16" height="16" fill="none" stroke="var(--accent)" stroke-width="2" viewBox="0 0 24 24">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
              Windows
            </h4>
            <p class="text-muted text-[0.85rem] leading-[1.5]">
              Native Windows build with NVIDIA CUDA acceleration. Download{' '}
              <code class="font-mono text-[0.8rem] bg-[oklch(12%_0.01_250)] px-[0.45em] py-[0.15em] rounded text-fg">.exe</code>{' '}
              from releases.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Install;
